import './FormTest.css'
import React from 'react'
import {FormInput} from './FormInput'
import {useApiPetition} from '../../hooks/useApiPetition' 

function FormTest({ inputTypes, nameInput, idInput}){

    const { 
        responseApi, 
        responseSecondApi, 
        error, 
        postApi, 
        postSecondApi 
    } = useApiPetition();

    const handleSubmit = async (ev) => {
        ev.preventDefault();

        const domain = ev.target.domain.value;
        console.log(domain);
        

        postApi('https://api.services.dominioya.com.co/api/update-dns/', { domain }).then(() => {
        
            if (responseApi && responseApi.data.result === 1) {
                postSecondApi('https://api.services.dominioya.com.co/api/park-domain/', { domain });
            }
        });

    }

    return(
        <>

            <form onSubmit={handleSubmit}>
                <ul>
                    <li className="form-camp">

                        {inputTypes.map((type, index) => (
                            
                            <FormInput 
                                key={index}
                                type={type}
                                label={nameInput[index]}
                                id={idInput[index]}
                            />

                        ))}
                    </li>

                    <li className="form-camp">
                        {/* <button type='submit' className='form-camp--button'>Search</button> */}
                        <button type='submit' className="continue-application">
                            <div>
                                <div className="pencil"></div>
                                <div className="folder">
                                    <div className="top">
                                        <svg viewBox="0 0 24 27">
                                            <path d="M1,0 L23,0 C23.5522847,-1.01453063e-16 24,0.44771525 24,1 L24,8.17157288 C24,8.70200585 23.7892863,9.21071368 23.4142136,9.58578644 L20.5857864,12.4142136 C20.2107137,12.7892863 20,13.2979941 20,13.8284271 L20,26 C20,26.5522847 19.5522847,27 19,27 L1,27 C0.44771525,27 6.76353751e-17,26.5522847 0,26 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z"></path>
                                        </svg>
                                    </div>
                                    <div className="paper"></div>
                                </div>
                            </div>
                            Buscar
                        </button>
                    </li>

                    {/* <li className="form-camp">
                        <span className='form-camp--tittle'>
                            El username ingresado fue: { data }
                        </span>
                    </li> */}

                </ul>
            </form>
            
            {responseApi && (
                <div className='container-responseApi'>
                    <h3 className='container-responseApi--title'>Domain Information:</h3>
                    <pre className='container-responseApi--response'>{JSON.stringify(responseApi, null, 2)}</pre>
                </div>
            )}

            <h2>RESULT SECOND API PARK:</h2>

            {responseSecondApi && (
                <div className='container-responseApi'>
                    <h3 className='container-responseApi--title'>Host Information:</h3>
                    <pre className='container-responseApi--response'>{JSON.stringify(responseSecondApi, null, 2)}</pre>
                </div>
            )}

            {error && (
                <div>
                    <h3>Error:</h3>
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                </div>
            )}

        </>
    )
}

export { FormTest }